module.exports = __webpack_public_path__ + "static/media/PG.7589d2d8.png";